(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$(document.body).on('click', '[data-scroll-to-top]', function (e) {
		e.preventDefault();

		// <html> for Fx - <body> for the rest
		$(document.body).animate({scrollTop: 0}, 200);
		$(document.documentElement).animate({scrollTop: 0}, 200);
	});
})();
